import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { useMPEFetch } from '@retail/app/hooks';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';
import { mpeApi } from '@retail/mgpris/config';
import { AssortmentPricesComparisonDTO } from '@retail/my-assortment/types';

interface Props extends QueryOptions {
  assortmentId: number;
  supplierNumber: number;
  conditionIds: number[];
}

export function useFetchAffectedItems({
  assortmentId,
  supplierNumber,
  conditionIds,
  ...queryOptions
}: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<AssortmentPricesComparisonDTO[]>({
    method: 'GET',
    queryKey: ['affected-items', supplierNumber, conditionIds],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.assortments.assortment.affectedSupplierItems.getFullLinkPath({ assortmentId }),
      searchParams: {
        supplierNumber,
        conditionIds,
      },
    }),
    ...queryOptions,
  });
}
